import { getSubStepValues } from '#models/general/steps';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';
import { getSelectField } from '#utils/select';

import styles from './styles.module.scss';
import { FEINT_MAIN_INFO_FIELDS, FEINTS_SUBSTEPS_IDS } from './constants';

export const FEINT_TYPE_OPTIONS = {
  PEATED: 'peated',
  UNPEATED: 'unpeated'
};

export const getMainInfoFields = ({ values, errors }) => {
  const getMainInfoValues = getSubStepValues(FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION, values, errors);
  return [
    getSelectField({
      field: FEINT_MAIN_INFO_FIELDS.FEINT_TYPE,
      values,
      options: FEINT_TYPE_OPTIONS,
      getValues: getMainInfoValues,
      substep: FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION
    }),
    {
      key: 'dip',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.DIP),
          Component: Input,
          noMargin: true
        },
        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.BULK),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'bulk',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.TEMP),
          Component: Input,
          noMargin: true
        },
        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.IND),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'temp',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.STRENGTH),
          Component: Input,
          noMargin: true
        },

        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.TCF),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'ind',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.CBULK),
          Component: Input,
          noMargin: true
        },
        {
          ...getMainInfoValues(FEINT_MAIN_INFO_FIELDS.LALC),
          Component: Input,
          noMargin: true
        }
      ]
    }
  ];
};
